import { z } from "zod";
import { AD_VERTICAL_CODES } from "./AdVerticals";
import { AD_OFFER_DETAILS_SCHEMA } from "./AdDetails";

export const CreateAdViewModelSchema = z.object({
  vertical: z.enum(AD_VERTICAL_CODES),
  details: AD_OFFER_DETAILS_SCHEMA.optional(),
});

export type CreateAdViewModel = z.infer<typeof CreateAdViewModelSchema>;
